<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <div class="modal-header">
      <img src="assets/icon/primary-close.svg" (click)="cancel()" class="modal-close" width="32" height="32"
        alt="Close Icon">
      <h4 class="modal-heading" translate>change-name-modal.title</h4>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <p class="smaller text-content" translate>change-name-modal.update-current-name</p>

        <form [formGroup]="nameForm">
          <label class="outlined-label-input">
            <input type="text" formControlName="firstName" placeholder=" ">
            <span translate>change-name-modal.first-name</span>
          </label>

          <p *ngIf="nameForm.controls['firstName'].touched && nameForm.controls['firstName'].hasError('required')"
            class="validation-message" translate>
            change-name-modal.first-name-required
          </p>

          <p *ngIf="nameForm.controls['firstName'].touched && nameForm.controls['firstName'].hasError('pattern')"
            class="validation-message" translate>
            change-name-modal.first-name-invalid
          </p>

          <label class="outlined-label-input second">
            <input type="text" formControlName="lastName" placeholder=" ">
            <span translate>change-name-modal.last-name</span>
          </label>

          <p *ngIf="nameForm.controls['lastName'].touched && nameForm.controls['lastName'].hasError('required')"
            class="validation-message" translate>
            change-name-modal.last-name-required
          </p>

          <p *ngIf="nameForm.controls['lastName'].touched && nameForm.controls['lastName'].hasError('pattern')"
            class="validation-message" translate>
            change-name-modal.last-name-invalid
          </p>
        </form>
      </div>

      <div class="modal-actions">
        <button class="button primary" (click)="updateName()" translate>
          change-name-modal.update
        </button>
        <button class="button tertiary" (click)="cancel()" translate>
          change-name-modal.cancel
        </button>
      </div>
    </div>
  </div>
</div>
